module.exports = __webpack_public_path__ + "static/faq-image-92d61a731c2f4e6a826b3cf6a58588ed.png";